import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ngClassObject } from '../../../types';
import { CommonModule } from '@angular/common';
import { IconsModule } from '../../icons/icons.module';

@Component({
  selector: 'p-button',
  templateUrl: './p-button.component.html',
  styleUrls: ['./p-button.component.scss'],
  standalone: true,
  imports: [CommonModule, IconsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PButtonComponent {
  @Input() level:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'primary-landing'
    | 'primary-landing-black' = 'primary';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() size?: 'large' | 'small';
  @Input() label?: string;
  @Input() width?: number;
  @Input() type: 'button' | 'submit' | 'menu' | 'reset' = 'submit';
  @Input() title!: string;
  @Input() iconName?: string;
  @Input() customClass = '';

  get classes(): ngClassObject<string> {
    return {
      'btn-primary text-white': this.level === 'primary',
      'btn-secondary text-white': this.level === 'secondary',
      'btn-tertiary border border-primary bg-white': this.level === 'tertiary',
      'rounded-bottom-start-50 rounded-top-end-50 rounded-top-start-0 rounded-bottom-end-0 px-4 py-2 text-white':
        this.level === 'primary-landing' ||
        this.level === 'primary-landing-black',
      'btn-primary-landing border green-primary-background':
        this.level === 'primary-landing',
      'btn-primary-landing-black bg-black':
        this.level === 'primary-landing-black',
      'btn-sm': this.size === 'small',
      'btn-lg': this.size === 'large',
      'd-flex align-items-center justify-content-center gap-2': !!this.iconName,
      [`w-${this.width}`]: !!this.width,
      [this.customClass]: !!this.customClass,
    };
  }
}
